// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Запити медіа» (Media requests, ключ `media`, група `communications`). */
export const mediaRequestsManifest: IModuleManifest = {
  key: 'media',
  group: 'communications',
  slug: 'media-requests',
  prefix: 'MED',
  name: { en: 'Media requests', uk: 'Запити медіа' },
  entities: [
    { key: 'media', slug: 'media', name: { en: 'Media requests', uk: 'Запити медіа' }, main: true },
    { key: 'media_request_outlet', slug: 'media-request-outlet', name: { en: 'Media request Outlets', uk: 'Видання' }, main: false },
    { key: 'media_request_spokesperson', slug: 'media-request-spokesperson', name: { en: 'Media request Spokespersons', uk: 'Речники' }, main: false },
    { key: 'media_request_briefing', slug: 'media-request-briefing', name: { en: 'Media request Briefings', uk: 'Брифінги' }, main: false },
    { key: 'media_request_status', slug: 'media-request-status', name: { en: 'Media request Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/mediaRequestsSlice').then((m) => m.mediaRequestsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
